/** @file The draft of the skin a skin command names (the default skin when the reference is omitted). */
import type { Draft } from 'immer';
import type { Doc, SkinDoc } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';

/** Resolves `ref` (or takes the default skin) and returns its mutable record; NOT_FOUND when missing. */
export function skinDraft(draft: Draft<Doc>, ctx: CommandContext, ref: string | undefined): Draft<SkinDoc> {
  const id = ref === undefined ? draft.defaultSkin : ctx.resolve('skin', ref);
  return draft.skins[id] ?? throwError('NOT_FOUND', { kind: 'skin', ref: id });
}
